import {gql} from "@apollo/client";
import {client} from "graphql/client";

// 创建仓库操作员
export const CREATE_ACCOUNT_WAREHOUSE_OPERATOR = gql`
    mutation CreateAccountWarehouseOperator($input: AccountWarehouseOperatorInput!) {
        createAccountWarehouseOperator(input: $input)
    }
`;

// 更新仓库操作员
export const UPDATE_ACCOUNT_WAREHOUSE_OPERATOR = gql`
    mutation UpdateAccountWarehouseOperator($input: AccountWarehouseOperatorInput!) {
        updateAccountWarehouseOperator(input: $input)
    }
`;

export interface AccountWarehouseOperatorInput {
    id?: string;
    email?: string;
    countryCode: number;
    phone?: string;
    password?: string;
    name: string;
    avatarStorageToken?: string;
    status: number;
    warehouseId: number;
    role: string;
}

export const createAccountWarehouseOperator = async (input: AccountWarehouseOperatorInput): Promise<boolean> => {
    const {data} = await client.mutate({
        mutation: CREATE_ACCOUNT_WAREHOUSE_OPERATOR,
        variables: {input}
    });
    return data.createAccountWarehouseOperator;
};

export const updateAccountWarehouseOperator = async (input: AccountWarehouseOperatorInput): Promise<boolean> => {
    const {data} = await client.mutate({
        mutation: UPDATE_ACCOUNT_WAREHOUSE_OPERATOR,
        variables: {input}
    });
    return data.updateAccountWarehouseOperator;
};